import Modal from "common/components/Modal/Modal"
import NewPagoForm from "features/Tesoreria/components/NewPagoForm"
import { CURRENT_PAYMENT_TYPE } from "features/Tesoreria/components/NewPagoForm/constants"
import { useDispatch } from "hooks/useDispatch"
import { useTranslation } from "react-i18next"
import { PagoCobroLineProps } from "../constants"

const NewPagoFormModal = ({
  handleCreateModal,
  handleCreate,
  show,
}: {
  handleCreateModal: (rowData: $TSMigrationFixMe, status: boolean) => void
  handleCreate: (key: $TSMigrationFixMe, values: $TSMigrationFixMe) => void
  show: PagoCobroLineProps
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <Modal
      header={`${
        show?.data?.remesaId
          ? t("cartera.modal.headerEdit")
          : t("cartera.modal.headerNew")
      } ${(show?.data?.tipo === CURRENT_PAYMENT_TYPE.PAGO
        ? t("pagoCobro.modal.labelPayment")
        : t("pagoCobro.modal.labelCollection")
      ).toLowerCase()}`}
      visible={show.status}
      onHide={() => handleCreateModal(null, false)}
      size='default'
      className='departaments-modal'
    >
      <NewPagoForm
        // @ts-expect-error TS(2322): Type '{ hideModal: () => void; dispatch: Dispatch<...
        hideModal={() => handleCreateModal(null, false)}
        dispatch={dispatch}
        onHide={() => handleCreateModal(null, false)}
        handleCreate={handleCreate}
        data={show.data}
        t={t}
      />
    </Modal>
  )
}

export default NewPagoFormModal
